// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Uuid = require("uuid");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Caml_splice_call = require("rescript/lib/js/caml_splice_call.js");
var DOM$SmartcutsMacros = require("../../DOM.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var Selector$SmartcutsMacros = require("../../Selector.bs.js");
var URLUtils$SmartcutsMacros = require("../../../../bs-utils/src/URLUtils.bs.js");
var CustomMap$SmartcutsMacros = require("../../CustomMap.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../../../bs-utils/src/ArrayUtils.bs.js");
var DOM__Search$SmartcutsMacros = require("../../devProtocol/DOM__Search.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../../bs-utils/src/OptionUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../../DOM__Element.bs.js");
var DOM__Document$SmartcutsMacros = require("../../DOM__Document.bs.js");
var DOM__Topology$SmartcutsMacros = require("../../DOM__Topology.bs.js");
var UrlConstraint$SmartcutsMacros = require("../../UrlConstraint.bs.js");
var PlaybackOptions$SmartcutsMacros = require("../../PlaybackOptions.bs.js");
var PlaybackParamValue$SmartcutsMacros = require("../../PlaybackParamValue.bs.js");
var MultiUrlTriggering__LinkGroup$SmartcutsMacros = require("./MultiUrlTriggering__LinkGroup.bs.js");

var Constants = {
  ignoreDeselectedGroupsOnPageTwoAndBeyond: true,
  acceptNewGroupsOnPageTwoAndBeyond: false,
  playbackModalWaitMillis: 5000.0
};

function t_encode(encoder_htmlElement, v) {
  if (v.TAG === /* AsSelector */0) {
    return [
            "AsSelector",
            Selector$SmartcutsMacros.selector_encode(v._0)
          ];
  } else {
    return [
            "AsHtmlElement",
            Curry._1(encoder_htmlElement, v._0),
            Selector$SmartcutsMacros.selector_encode(v._1)
          ];
  }
}

function t_decode(decoder_htmlElement, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AsHtmlElement" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Curry._1(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* AsHtmlElement */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "AsSelector" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* AsSelector */0,
                      _0: v0._0
                    }
                  };
          }
          var e$2 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function asHtmlElement(clickTarget) {
  if (clickTarget.TAG === /* AsSelector */0) {
    return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, /* Document */0, false, undefined, undefined, undefined, clickTarget._0).then(function (result_element) {
                if (result_element.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result_element._0
                            });
                }
                var arg = Webapi__Dom__Element.asHtmlElement(result_element._0);
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: (function (param) {
                                  return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                })("Expected to be able to convert element to html element")
                          });
              });
  }
  var htmlElement = clickTarget._0;
  if (DOM__Element$SmartcutsMacros.contains(DOM__Document$SmartcutsMacros.getBodyExn(undefined), htmlElement)) {
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: htmlElement
              });
  } else {
    return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, /* Document */0, true, undefined, undefined, undefined, clickTarget._1).then(function (result_element) {
                if (result_element.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result_element._0
                            });
                }
                var arg = Webapi__Dom__Element.asHtmlElement(result_element._0);
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: (function (param) {
                                  return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                })("Expected to be able to convert element to html element")
                          });
              });
  }
}

function map(mapHtmlElement, clickTarget) {
  if (clickTarget.TAG === /* AsSelector */0) {
    return {
            TAG: /* AsSelector */0,
            _0: clickTarget._0
          };
  } else {
    return {
            TAG: /* AsHtmlElement */1,
            _0: Curry._1(mapHtmlElement, clickTarget._0),
            _1: clickTarget._1
          };
  }
}

var ClickTarget = {
  t_encode: t_encode,
  t_decode: t_decode,
  asHtmlElement: asHtmlElement,
  map: map
};

function t_encode$1(encoder_htmlElement, v) {
  if (v.TAG === /* FindAndClick */0) {
    return [
            "FindAndClick",
            t_encode(encoder_htmlElement, v._0)
          ];
  } else {
    return [
            "ScrollBy",
            Decco.floatToJson(v._0)
          ];
  }
}

function t_decode$1(decoder_htmlElement, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FindAndClick" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FindAndClick */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ScrollBy" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ScrollBy */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(paginateFn) {
  if (paginateFn.TAG === /* FindAndClick */0) {
    if (paginateFn._0.TAG === /* AsSelector */0) {
      return "FindAndClick(AsSelector(selector)";
    } else {
      return "FindAndClick(AsHtmlElement(htmlElement, selector))";
    }
  } else {
    return "ScrollBy(" + (paginateFn._0.toString() + ")");
  }
}

function map$1(mapHtmlElement, paginateFn) {
  if (paginateFn.TAG === /* FindAndClick */0) {
    return {
            TAG: /* FindAndClick */0,
            _0: map(mapHtmlElement, paginateFn._0)
          };
  } else {
    return {
            TAG: /* ScrollBy */1,
            _0: paginateFn._0
          };
  }
}

function fromPaginateFn(paginateFn) {
  if (paginateFn.TAG === /* FindAndClick */0) {
    return {
            TAG: /* FindAndClick */0,
            _0: {
              TAG: /* AsSelector */0,
              _0: paginateFn._0
            }
          };
  } else {
    return {
            TAG: /* ScrollBy */1,
            _0: paginateFn._0
          };
  }
}

function toPaginateFn(paginateFn) {
  if (paginateFn.TAG !== /* FindAndClick */0) {
    return {
            TAG: /* ScrollBy */1,
            _0: paginateFn._0
          };
  }
  var selector = paginateFn._0;
  if (selector.TAG === /* AsSelector */0) {
    return {
            TAG: /* FindAndClick */0,
            _0: selector._0
          };
  } else {
    return {
            TAG: /* FindAndClick */0,
            _0: selector._1
          };
  }
}

var PaginateFnWithPolymorphicClickTargetRepresentation = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify,
  map: map$1,
  fromPaginateFn: fromPaginateFn,
  toPaginateFn: toPaginateFn
};

function t_encode$2(v) {
  return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_encode, v);
}

function t_decode$2(v) {
  return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_decode, v);
}

var size = Belt_MapString.size;

function isEmpty(v) {
  return Belt_MapString.size(v) === 0;
}

function findGroupIdForElement(element, linkGroups) {
  var maybeGroupIdWithGroup = Belt_MapString.findFirstBy(linkGroups, (function (_groupId, param) {
          return Curry._3(DOM__Topology$SmartcutsMacros.ElementGrouper.SelectorPattern.doesMatchElement, 3, element, param.selectorPattern);
        }));
  return OptionUtils$SmartcutsMacros.map(maybeGroupIdWithGroup, (function (param) {
                return param[0];
              }));
}

function calcLinkGroupsToKeep(maybePaginateFn, isRecordingPageAction, linkGroups) {
  var hasStartedPagination = maybePaginateFn !== undefined;
  if (!hasStartedPagination && !isRecordingPageAction) {
    if (Belt_MapString.size(linkGroups) === 1) {
      return Caml_option.some(linkGroups);
    } else {
      return ;
    }
  }
  return Caml_option.some(Belt_MapString.keep(linkGroups, (function (_groupId, param) {
                    return param.selected;
                  })));
}

var LinkGroups = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  size: size,
  isEmpty: isEmpty,
  findGroupIdForElement: findGroupIdForElement,
  calcLinkGroupsToKeep: calcLinkGroupsToKeep
};

function linkInfo_decode(decoder_htmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var href = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "href"), null));
    if (href.TAG === /* Ok */0) {
      var innerText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerText"), null));
      if (innerText.TAG === /* Ok */0) {
        var selected = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selected"), null));
        if (selected.TAG === /* Ok */0) {
          var index = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "index"), null));
          if (index.TAG === /* Ok */0) {
            var isInCurrDom = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isInCurrDom"), null));
            if (isInCurrDom.TAG === /* Ok */0) {
              var pageNumber = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageNumber"), null));
              if (pageNumber.TAG === /* Ok */0) {
                var element = Curry._1(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "element"), null));
                if (element.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            id: id._0,
                            href: href._0,
                            innerText: innerText._0,
                            selected: selected._0,
                            index: index._0,
                            isInCurrDom: isInCurrDom._0,
                            pageNumber: pageNumber._0,
                            element: element._0
                          }
                        };
                }
                var e = element._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".element" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = pageNumber._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".pageNumber" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = isInCurrDom._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".isInCurrDom" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = index._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".index" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = selected._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".selected" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = innerText._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".innerText" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = href._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".href" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function linkInfo_encode(encoder_htmlElement, v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "href",
                Decco.stringToJson(v.href)
              ],
              [
                "innerText",
                Decco.stringToJson(v.innerText)
              ],
              [
                "selected",
                Decco.boolToJson(v.selected)
              ],
              [
                "index",
                Decco.intToJson(v.index)
              ],
              [
                "isInCurrDom",
                Decco.boolToJson(v.isInCurrDom)
              ],
              [
                "pageNumber",
                Decco.intToJson(v.pageNumber)
              ],
              [
                "element",
                Curry._1(encoder_htmlElement, v.element)
              ]
            ]);
}

function t_encode$3(encoder_htmlElement, v) {
  if (v.TAG === /* Link */0) {
    return [
            "Link",
            linkInfo_encode(encoder_htmlElement, v._0)
          ];
  } else {
    return [
            "LinkWithGroup",
            linkInfo_encode(encoder_htmlElement, v._0),
            Decco.stringToJson(v._1)
          ];
  }
}

function t_decode$3(decoder_htmlElement, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Link" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = linkInfo_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Link */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "LinkWithGroup" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = linkInfo_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* LinkWithGroup */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function mapInnerLinkInfo(f, link) {
  if (link.TAG === /* Link */0) {
    return {
            TAG: /* Link */0,
            _0: Curry._1(f, link._0)
          };
  } else {
    return {
            TAG: /* LinkWithGroup */1,
            _0: Curry._1(f, link._0),
            _1: link._1
          };
  }
}

function deserializeLinkInfo(param) {
  return {
          id: param.id,
          href: param.href,
          innerText: param.innerText,
          selected: param.selected,
          index: param.index,
          isInCurrDom: param.isInCurrDom,
          pageNumber: param.pageNumber,
          element: document.createElement("div")
        };
}

function deserialize(link) {
  if (link.TAG === /* Link */0) {
    return {
            TAG: /* Link */0,
            _0: deserializeLinkInfo(link._0)
          };
  } else {
    return {
            TAG: /* LinkWithGroup */1,
            _0: deserializeLinkInfo(link._0),
            _1: link._1
          };
  }
}

var ForSerialization = {
  deserializeLinkInfo: deserializeLinkInfo,
  deserialize: deserialize
};

function makeLinkFromElement(pageNumber, index, element) {
  var arg = DOM$SmartcutsMacros.HtmlAnchorElement.ofElement(element);
  var href = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expect a[href] as html anchor element").href;
  var innerText = element.innerText;
  return {
          TAG: /* Link */0,
          _0: {
            id: Uuid.v1(),
            href: href,
            innerText: innerText,
            selected: true,
            index: index,
            isInCurrDom: true,
            pageNumber: pageNumber,
            element: element
          }
        };
}

function makeLinkWithGroupFromElementAndGroupId(pageNumber, index, element, groupId) {
  var arg = DOM$SmartcutsMacros.HtmlAnchorElement.ofElement(element);
  var href = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expect a[href] as html anchor element").href;
  var innerText = element.innerText;
  return {
          TAG: /* LinkWithGroup */1,
          _0: {
            id: Uuid.v1(),
            href: href,
            innerText: innerText,
            selected: true,
            index: index,
            isInCurrDom: true,
            pageNumber: pageNumber,
            element: element
          },
          _1: groupId
        };
}

function isLinkWithoutGroup(link) {
  if (link.TAG === /* Link */0) {
    return true;
  } else {
    return false;
  }
}

function isLinkInAnyGroup(groups, link) {
  if (link.TAG === /* Link */0 || !Belt_MapString.has(groups, link._1)) {
    return false;
  } else {
    return true;
  }
}

function mapLinkInfo(mapHtmlElement, param) {
  return {
          id: param.id,
          href: param.href,
          innerText: param.innerText,
          selected: param.selected,
          index: param.index,
          isInCurrDom: param.isInCurrDom,
          pageNumber: param.pageNumber,
          element: Curry._1(mapHtmlElement, param.element)
        };
}

function stringifyLinkInfo(stringifyHtmlElement, param) {
  return "{id: " + (param.id + (", href: " + (param.href + (", innerText: " + (param.innerText + (", selected: " + (Pervasives.string_of_bool(param.selected) + (", index: " + (String(param.index) + (", pageNumber: " + (String(param.pageNumber) + (", element: " + Curry._1(stringifyHtmlElement, param.element)))))))))))));
}

function stringify$1(stringifyHtmlElement, link) {
  if (link.TAG === /* Link */0) {
    return "Link(" + (stringifyLinkInfo(stringifyHtmlElement, link._0) + ")");
  } else {
    return "LinkWithGroup(" + (stringifyLinkInfo(stringifyHtmlElement, link._0) + (", groupId=" + (link._1 + ")")));
  }
}

function mapLink(mapHtmlElement, link) {
  if (link.TAG === /* Link */0) {
    return {
            TAG: /* Link */0,
            _0: mapLinkInfo(mapHtmlElement, link._0)
          };
  } else {
    return {
            TAG: /* LinkWithGroup */1,
            _0: mapLinkInfo(mapHtmlElement, link._0),
            _1: link._1
          };
  }
}

function updateLinkInfo(f, v) {
  if (v.TAG === /* Link */0) {
    return {
            TAG: /* Link */0,
            _0: Curry._1(f, v._0)
          };
  } else {
    return {
            TAG: /* LinkWithGroup */1,
            _0: Curry._1(f, v._0),
            _1: v._1
          };
  }
}

function predicate(f, link) {
  return Curry._1(f, link._0);
}

function isSelected(link) {
  return link._0.selected;
}

function isNotSelected(link) {
  return !link._0.selected;
}

function isGrouped(v) {
  if (v.TAG === /* Link */0) {
    return false;
  } else {
    return true;
  }
}

function belongsToGroup(groupId, v) {
  if (v.TAG === /* Link */0) {
    return false;
  } else {
    return groupId === v._1;
  }
}

function doesMatchHref(href, v) {
  return v._0.href === href;
}

function doesMatchPageNumberAndHref(pageNumber, href, v) {
  var linkInfo = v._0;
  if (linkInfo.pageNumber === pageNumber) {
    return linkInfo.href === href;
  } else {
    return false;
  }
}

function getLinkInfo(link) {
  return link._0;
}

function getHref(link) {
  return link._0.href;
}

var Link = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  linkInfo_encode: linkInfo_encode,
  linkInfo_decode: linkInfo_decode,
  mapInnerLinkInfo: mapInnerLinkInfo,
  ForSerialization: ForSerialization,
  makeLinkFromElement: makeLinkFromElement,
  makeLinkWithGroupFromElementAndGroupId: makeLinkWithGroupFromElementAndGroupId,
  isLinkWithoutGroup: isLinkWithoutGroup,
  isLinkInAnyGroup: isLinkInAnyGroup,
  mapLinkInfo: mapLinkInfo,
  stringifyLinkInfo: stringifyLinkInfo,
  stringify: stringify$1,
  mapLink: mapLink,
  updateLinkInfo: updateLinkInfo,
  predicate: predicate,
  isSelected: isSelected,
  isNotSelected: isNotSelected,
  isGrouped: isGrouped,
  belongsToGroup: belongsToGroup,
  doesMatchHref: doesMatchHref,
  doesMatchPageNumberAndHref: doesMatchPageNumberAndHref,
  getLinkInfo: getLinkInfo,
  getHref: getHref
};

var link_encode = t_encode$3;

var link_decode = t_decode$3;

function size$1(links) {
  return links.length;
}

function isEmpty$1(links) {
  return links.length === 0;
}

function calcMaxPage(links) {
  return Caml_splice_call.spliceApply(Math.max, [Belt_Array.map(links, (function (link) {
                      return link._0.pageNumber;
                    }))]);
}

function refreshIsInCurrDomFlags(links) {
  return Belt_Array.map(links, (function (link) {
                if (!link._0.isInCurrDom) {
                  return link;
                }
                if (link.TAG === /* Link */0) {
                  var linkInfo = link._0;
                  return {
                          TAG: /* Link */0,
                          _0: {
                            id: linkInfo.id,
                            href: linkInfo.href,
                            innerText: linkInfo.innerText,
                            selected: linkInfo.selected,
                            index: linkInfo.index,
                            isInCurrDom: DOM__Element$SmartcutsMacros.contains(DOM__Document$SmartcutsMacros.getBodyExn(undefined), linkInfo.element),
                            pageNumber: linkInfo.pageNumber,
                            element: linkInfo.element
                          }
                        };
                }
                var linkInfo$1 = link._0;
                return {
                        TAG: /* LinkWithGroup */1,
                        _0: {
                          id: linkInfo$1.id,
                          href: linkInfo$1.href,
                          innerText: linkInfo$1.innerText,
                          selected: linkInfo$1.selected,
                          index: linkInfo$1.index,
                          isInCurrDom: DOM__Element$SmartcutsMacros.contains(DOM__Document$SmartcutsMacros.getBodyExn(undefined), linkInfo$1.element),
                          pageNumber: linkInfo$1.pageNumber,
                          element: linkInfo$1.element
                        },
                        _1: link._1
                      };
              }));
}

function flagLinksFromPriorPageLoadsAsNotInCurrDom(links) {
  return Belt_Array.map(links, (function (link) {
                return mapInnerLinkInfo((function (linkInfo) {
                              return {
                                      id: linkInfo.id,
                                      href: linkInfo.href,
                                      innerText: linkInfo.innerText,
                                      selected: linkInfo.selected,
                                      index: linkInfo.index,
                                      isInCurrDom: false,
                                      pageNumber: linkInfo.pageNumber,
                                      element: linkInfo.element
                                    };
                            }), link);
              }));
}

function getMaxPageOfLinks(links) {
  if (links.length === 0) {
    return ;
  } else {
    return Caml_splice_call.spliceApply(Math.max, [Belt_Array.map(links, (function (link) {
                        return link._0.pageNumber;
                      }))]);
  }
}

function renumber(links) {
  return Belt_Array.mapWithIndex(links, (function (index, link) {
                if (link.TAG === /* Link */0) {
                  var linkInfo = link._0;
                  return {
                          TAG: /* Link */0,
                          _0: {
                            id: linkInfo.id,
                            href: linkInfo.href,
                            innerText: linkInfo.innerText,
                            selected: linkInfo.selected,
                            index: index,
                            isInCurrDom: linkInfo.isInCurrDom,
                            pageNumber: linkInfo.pageNumber,
                            element: linkInfo.element
                          }
                        };
                }
                var linkInfo$1 = link._0;
                return {
                        TAG: /* LinkWithGroup */1,
                        _0: {
                          id: linkInfo$1.id,
                          href: linkInfo$1.href,
                          innerText: linkInfo$1.innerText,
                          selected: linkInfo$1.selected,
                          index: index,
                          isInCurrDom: linkInfo$1.isInCurrDom,
                          pageNumber: linkInfo$1.pageNumber,
                          element: linkInfo$1.element
                        },
                        _1: link._1
                      };
              }));
}

function keepOnlyLinksInCurrentDom(links) {
  return Belt_Array.keep(links, (function (link) {
                return link._0.isInCurrDom;
              }));
}

function filterByGroupId(groupId, links) {
  return Belt_Array.keep(links, (function (link) {
                if (link.TAG === /* Link */0) {
                  return false;
                } else {
                  return link._1 === groupId;
                }
              }));
}

function keepLinksOnlyFromGroup(group, groupId, links) {
  return renumber(Belt_Array.keepMap(links, (function (link) {
                    if (link.TAG !== /* Link */0) {
                      return link;
                    }
                    var linkInfo = link._0;
                    if (MultiUrlTriggering__LinkGroup$SmartcutsMacros.doesMatchElement(undefined, linkInfo.element, group)) {
                      return {
                              TAG: /* LinkWithGroup */1,
                              _0: linkInfo,
                              _1: groupId
                            };
                    }
                    
                  })));
}

function keepLinksOnlyFromSelectedGroups(allGroups, links) {
  var selectedGroups = Belt_MapString.keep(allGroups, (function (_groupId, param) {
          return param.selected;
        }));
  return renumber(Belt_Array.keep(links, (function (param) {
                    return isLinkInAnyGroup(selectedGroups, param);
                  })));
}

function dedupeLinksInEachGroup(links) {
  return Belt_Array.reduce(links, [
                undefined,
                []
              ], (function (param, link) {
                  var uniqueLinks = param[1];
                  var hrefsByGroup = param[0];
                  if (link.TAG === /* Link */0) {
                    return [
                            hrefsByGroup,
                            $$Array.append(uniqueLinks, [link])
                          ];
                  }
                  var groupId = link._1;
                  var href = link._0.href;
                  var hrefsThatWeHaveAlreadySeenInThisGroup = Belt_MapString.get(hrefsByGroup, groupId);
                  if (hrefsThatWeHaveAlreadySeenInThisGroup !== undefined) {
                    if ($$Array.mem(href, hrefsThatWeHaveAlreadySeenInThisGroup)) {
                      return [
                              hrefsByGroup,
                              uniqueLinks
                            ];
                    } else {
                      return [
                              Belt_MapString.set(hrefsByGroup, groupId, $$Array.append(hrefsThatWeHaveAlreadySeenInThisGroup, [href])),
                              $$Array.append(uniqueLinks, [link])
                            ];
                    }
                  } else {
                    return [
                            Belt_MapString.set(hrefsByGroup, groupId, [href]),
                            $$Array.append(uniqueLinks, [link])
                          ];
                  }
                }))[1];
}

function mapWithLinkInfo(f, links) {
  return Belt_Array.map(links, (function (link) {
                return Curry._1(f, link._0);
              }));
}

var Links = {
  size: size$1,
  isEmpty: isEmpty$1,
  calcMaxPage: calcMaxPage,
  refreshIsInCurrDomFlags: refreshIsInCurrDomFlags,
  flagLinksFromPriorPageLoadsAsNotInCurrDom: flagLinksFromPriorPageLoadsAsNotInCurrDom,
  getMaxPageOfLinks: getMaxPageOfLinks,
  renumber: renumber,
  keepOnlyLinksInCurrentDom: keepOnlyLinksInCurrentDom,
  filterByGroupId: filterByGroupId,
  keepLinksOnlyFromGroup: keepLinksOnlyFromGroup,
  keepLinksOnlyFromSelectedGroups: keepLinksOnlyFromSelectedGroups,
  dedupeLinksInEachGroup: dedupeLinksInEachGroup,
  mapWithLinkInfo: mapWithLinkInfo
};

function remainingPages_encode(v) {
  if (typeof v === "number") {
    return ["UnknownRemainingPages"];
  } else if (v.TAG === /* RemainingPages */0) {
    return [
            "RemainingPages",
            Decco.intToJson(v._0)
          ];
  } else {
    return [
            "TotalItems",
            Decco.intToJson(v._0)
          ];
  }
}

function remainingPages_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "RemainingPages" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RemainingPages */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "TotalItems" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TotalItems */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "UnknownRemainingPages" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* UnknownRemainingPages */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function remainingPagesFromPageUntil(pageUntil) {
  if (typeof pageUntil === "number") {
    if (pageUntil === /* UntilAllPages */0) {
      return /* UnknownRemainingPages */0;
    } else {
      return {
              TAG: /* RemainingPages */0,
              _0: 0
            };
    }
  } else if (pageUntil.TAG === /* UntilNextNPages */0) {
    return {
            TAG: /* RemainingPages */0,
            _0: pageUntil._0
          };
  } else {
    return {
            TAG: /* TotalItems */1,
            _0: pageUntil._0
          };
  }
}

function stringifyRemainingPages(v) {
  if (typeof v === "number") {
    return "UnknownRemainingPages";
  } else if (v.TAG === /* RemainingPages */0) {
    return "RemainingPages(" + (String(v._0) + ")");
  } else {
    return "|TotalItems(" + v._0 + ")";
  }
}

function pageAction_encode(v) {
  if (v) {
    return [
            "InfiniteScroll",
            Decco.floatToJson(v._0)
          ];
  } else {
    return ["ClickNextPage"];
  }
}

function pageAction_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ClickNextPage" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ClickNextPage */0
                  };
          }
      case "InfiniteScroll" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* InfiniteScroll */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function recordingPageAction_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var pageAction = pageAction_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageAction"), null));
  if (pageAction.TAG === /* Ok */0) {
    var numLinksBeforeRecordingPageAction = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numLinksBeforeRecordingPageAction"), null));
    if (numLinksBeforeRecordingPageAction.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                pageAction: pageAction._0,
                numLinksBeforeRecordingPageAction: numLinksBeforeRecordingPageAction._0
              }
            };
    }
    var e = numLinksBeforeRecordingPageAction._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".numLinksBeforeRecordingPageAction" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = pageAction._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".pageAction" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function recordingPageAction_encode(v) {
  return Js_dict.fromArray([
              [
                "pageAction",
                pageAction_encode(v.pageAction)
              ],
              [
                "numLinksBeforeRecordingPageAction",
                Decco.intToJson(v.numLinksBeforeRecordingPageAction)
              ]
            ]);
}

function t_encode$4(v) {
  if (typeof v === "number") {
    switch (v) {
      case /* SelectingUrls */0 :
          return ["SelectingUrls"];
      case /* ChoosePageAction */1 :
          return ["ChoosePageAction"];
      case /* AwaitingTryFirstClickPageAction */2 :
          return ["AwaitingTryFirstClickPageAction"];
      case /* TryingFirstClickPageAction */3 :
          return ["TryingFirstClickPageAction"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* RecordingPageAction */0 :
          return [
                  "RecordingPageAction",
                  recordingPageAction_encode(v._0)
                ];
      case /* ReviewLinksAfterRecordPageAction */1 :
          return [
                  "ReviewLinksAfterRecordPageAction",
                  pageAction_encode(v._0)
                ];
      case /* PlaybackPagination */2 :
          return [
                  "PlaybackPagination",
                  Decco.intToJson(v._0),
                  remainingPages_encode(v._1),
                  pageAction_encode(v._2)
                ];
      case /* ReviewLinksAfterPaginationPlayback */3 :
          return [
                  "ReviewLinksAfterPaginationPlayback",
                  pageAction_encode(v._0),
                  PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode(v._1),
                  PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__encode(v._2)
                ];
      case /* ChoosePlaybackParams */4 :
          return [
                  "ChoosePlaybackParams",
                  pageAction_encode(v._0),
                  PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode(v._1),
                  PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__encode(v._2)
                ];
      case /* ChoosePlaybackOptionsAndExecute */5 :
          return [
                  "ChoosePlaybackOptionsAndExecute",
                  pageAction_encode(v._0),
                  PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode(v._1),
                  PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__encode(v._2)
                ];
      
    }
  }
}

function t_decode$4(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AwaitingTryFirstClickPageAction" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AwaitingTryFirstClickPageAction */2
                  };
          }
      case "ChoosePageAction" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ChoosePageAction */1
                  };
          }
      case "ChoosePlaybackOptionsAndExecute" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = pageAction_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__decode(Belt_Array.getExn(jsonArr$1, 3));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* ChoosePlaybackOptionsAndExecute */5,
                          _0: match$1._0,
                          _1: match$2._0,
                          _2: match$3._0
                        }
                      };
              }
              var e = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "ChoosePlaybackParams" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$4 = pageAction_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$5 = PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$6 = PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__decode(Belt_Array.getExn(jsonArr$1, 3));
          if (match$4.TAG === /* Ok */0) {
            if (match$5.TAG === /* Ok */0) {
              if (match$6.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* ChoosePlaybackParams */4,
                          _0: match$4._0,
                          _1: match$5._0,
                          _2: match$6._0
                        }
                      };
              }
              var e$3 = match$6._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                      }
                    };
            }
            var e$4 = match$5._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = match$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "PlaybackPagination" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$7 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$8 = remainingPages_decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$9 = pageAction_decode(Belt_Array.getExn(jsonArr$1, 3));
          if (match$7.TAG === /* Ok */0) {
            if (match$8.TAG === /* Ok */0) {
              if (match$9.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* PlaybackPagination */2,
                          _0: match$7._0,
                          _1: match$8._0,
                          _2: match$9._0
                        }
                      };
              }
              var e$6 = match$9._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                      }
                    };
            }
            var e$7 = match$8._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$7.path,
                      message: e$7.message,
                      value: e$7.value
                    }
                  };
          }
          var e$8 = match$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "RecordingPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = recordingPageAction_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RecordingPageAction */0,
                      _0: v0._0
                    }
                  };
          }
          var e$9 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "ReviewLinksAfterPaginationPlayback" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$10 = pageAction_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$11 = PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$12 = PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__decode(Belt_Array.getExn(jsonArr$1, 3));
          if (match$10.TAG === /* Ok */0) {
            if (match$11.TAG === /* Ok */0) {
              if (match$12.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* ReviewLinksAfterPaginationPlayback */3,
                          _0: match$10._0,
                          _1: match$11._0,
                          _2: match$12._0
                        }
                      };
              }
              var e$10 = match$12._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                      }
                    };
            }
            var e$11 = match$11._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$11.path,
                      message: e$11.message,
                      value: e$11.value
                    }
                  };
          }
          var e$12 = match$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "ReviewLinksAfterRecordPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = pageAction_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ReviewLinksAfterRecordPageAction */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$13 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "SelectingUrls" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SelectingUrls */0
                  };
          }
      case "TryingFirstClickPageAction" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TryingFirstClickPageAction */3
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyPageAction(v) {
  if (v) {
    return "InfiniteScroll(" + (v._0.toString() + ")");
  } else {
    return "ClickNextPage";
  }
}

function stringify$2(step) {
  if (typeof step === "number") {
    switch (step) {
      case /* SelectingUrls */0 :
          return "SelectingUrls";
      case /* ChoosePageAction */1 :
          return "ChoosePageAction";
      case /* AwaitingTryFirstClickPageAction */2 :
          return "AwaitingTryFirstClickPageAction";
      case /* TryingFirstClickPageAction */3 :
          return "TryingFirstClickPageAction";
      
    }
  } else {
    switch (step.TAG | 0) {
      case /* RecordingPageAction */0 :
          var match = step._0;
          return "RecordingPageAction({pageAction: " + (stringifyPageAction(match.pageAction) + (", numLinksBeforeRecordingPageAction: " + (String(match.numLinksBeforeRecordingPageAction) + "})")));
      case /* ReviewLinksAfterRecordPageAction */1 :
          return "ReviewLinksAfterRecordPageAction(" + (stringifyPageAction(step._0) + ")");
      case /* PlaybackPagination */2 :
          return "PlaybackPagination(" + (String(step._0) + (", " + (stringifyRemainingPages(step._1) + (", " + (stringifyPageAction(step._2) + ")")))));
      case /* ReviewLinksAfterPaginationPlayback */3 :
          return "ReviewLinksAfterPaginationPlayback(" + (stringifyPageAction(step._0) + ", playbackOptions, playbackParamValuesByCommandIndex)");
      case /* ChoosePlaybackParams */4 :
          return "ChoosePlaybackParams(" + (stringifyPageAction(step._0) + ", playbackOptions, playbackParamValuesByCommandIndex)");
      case /* ChoosePlaybackOptionsAndExecute */5 :
          return "ChoosePlaybackOptionsAndExecute(" + (stringifyPageAction(step._0) + ", playbackOptions, playbackParamValuesByCommandIndex)");
      
    }
  }
}

function didRecordPageAction(step) {
  if (typeof step === "number") {
    switch (step) {
      case /* SelectingUrls */0 :
      case /* ChoosePageAction */1 :
          return false;
      default:
        return true;
    }
  } else {
    switch (step.TAG | 0) {
      case /* RecordingPageAction */0 :
          return false;
      case /* PlaybackPagination */2 :
          return true;
      default:
        return true;
    }
  }
}

function maybePageActionGet(step) {
  if (typeof step === "number") {
    switch (step) {
      case /* SelectingUrls */0 :
      case /* ChoosePageAction */1 :
          return ;
      case /* AwaitingTryFirstClickPageAction */2 :
      case /* TryingFirstClickPageAction */3 :
          return /* ClickNextPage */0;
      
    }
  } else {
    switch (step.TAG | 0) {
      case /* RecordingPageAction */0 :
          return step._0.pageAction;
      case /* PlaybackPagination */2 :
          return step._2;
      default:
        return step._0;
    }
  }
}

function nextStep(maybePageAction, links, step) {
  if (typeof step === "number") {
    switch (step) {
      case /* SelectingUrls */0 :
          return calcMaxPage(links) === 2 || didRecordPageAction(step) ? ({
                      TAG: /* ReviewLinksAfterRecordPageAction */1,
                      _0: OptionUtils$SmartcutsMacros.getExn("Expected pageAction", maybePageAction)
                    }) : /* ChoosePageAction */1;
      case /* AwaitingTryFirstClickPageAction */2 :
      case /* TryingFirstClickPageAction */3 :
          return {
                  TAG: /* ReviewLinksAfterRecordPageAction */1,
                  _0: /* ClickNextPage */0
                };
      default:
        return ;
    }
  } else {
    switch (step.TAG | 0) {
      case /* RecordingPageAction */0 :
          return {
                  TAG: /* ReviewLinksAfterRecordPageAction */1,
                  _0: step._0.pageAction
                };
      case /* ReviewLinksAfterRecordPageAction */1 :
          return {
                  TAG: /* PlaybackPagination */2,
                  _0: 1,
                  _1: {
                    TAG: /* RemainingPages */0,
                    _0: -1
                  },
                  _2: step._0
                };
      case /* ReviewLinksAfterPaginationPlayback */3 :
          var playbackParamValuesByCommandIndex = step._2;
          var playbackOptions = step._1;
          var pageActon = step._0;
          if (Belt_MapInt.size(playbackParamValuesByCommandIndex) <= 1) {
            return {
                    TAG: /* ChoosePlaybackOptionsAndExecute */5,
                    _0: pageActon,
                    _1: playbackOptions,
                    _2: playbackParamValuesByCommandIndex
                  };
          } else {
            return {
                    TAG: /* ChoosePlaybackParams */4,
                    _0: pageActon,
                    _1: playbackOptions,
                    _2: playbackParamValuesByCommandIndex
                  };
          }
      case /* ChoosePlaybackParams */4 :
          return {
                  TAG: /* ChoosePlaybackOptionsAndExecute */5,
                  _0: step._0,
                  _1: step._1,
                  _2: step._2
                };
      default:
        return ;
    }
  }
}

function prevStep(links, step) {
  if (typeof step === "number") {
    switch (step) {
      case /* SelectingUrls */0 :
          return ;
      case /* ChoosePageAction */1 :
          return /* SelectingUrls */0;
      default:
        return /* ChoosePageAction */1;
    }
  } else {
    switch (step.TAG | 0) {
      case /* ReviewLinksAfterRecordPageAction */1 :
          return /* ChoosePageAction */1;
      case /* PlaybackPagination */2 :
          var _nRemaining = step._1;
          if (typeof _nRemaining !== "number" && _nRemaining.TAG === /* RemainingPages */0 && _nRemaining._0 === -1) {
            return {
                    TAG: /* ReviewLinksAfterRecordPageAction */1,
                    _0: step._2
                  };
          }
          return {
                  TAG: /* PlaybackPagination */2,
                  _0: step._0,
                  _1: {
                    TAG: /* RemainingPages */0,
                    _0: -1
                  },
                  _2: step._2
                };
      case /* ReviewLinksAfterPaginationPlayback */3 :
          return calcMaxPage(links) === 2 || didRecordPageAction(step) ? ({
                      TAG: /* PlaybackPagination */2,
                      _0: 1,
                      _1: {
                        TAG: /* RemainingPages */0,
                        _0: -1
                      },
                      _2: step._0
                    }) : /* ChoosePageAction */1;
      case /* ChoosePlaybackParams */4 :
          return {
                  TAG: /* ReviewLinksAfterPaginationPlayback */3,
                  _0: step._0,
                  _1: step._1,
                  _2: step._2
                };
      case /* ChoosePlaybackOptionsAndExecute */5 :
          var playbackParamValuesByCommandIndex = step._2;
          var playbackOptions = step._1;
          var pageActon = step._0;
          if (Belt_MapInt.size(playbackParamValuesByCommandIndex) <= 1) {
            return {
                    TAG: /* ReviewLinksAfterPaginationPlayback */3,
                    _0: pageActon,
                    _1: playbackOptions,
                    _2: playbackParamValuesByCommandIndex
                  };
          } else {
            return {
                    TAG: /* ChoosePlaybackParams */4,
                    _0: pageActon,
                    _1: playbackOptions,
                    _2: playbackParamValuesByCommandIndex
                  };
          }
      default:
        return /* ChoosePageAction */1;
    }
  }
}

var Step = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  recordingPageAction_encode: recordingPageAction_encode,
  recordingPageAction_decode: recordingPageAction_decode,
  stringifyPageAction: stringifyPageAction,
  stringify: stringify$2,
  didRecordPageAction: didRecordPageAction,
  maybePageActionGet: maybePageActionGet,
  nextStep: nextStep,
  prevStep: prevStep
};

function initState_encode(encoder_htmlElement, v) {
  return Js_dict.fromArray([
              [
                "links",
                Decco.arrayToJson((function (param) {
                        return link_encode(encoder_htmlElement, param);
                      }), v.links)
              ],
              [
                "linkGroups",
                CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_encode, v.linkGroups)
              ],
              [
                "step",
                t_encode$4(v.step)
              ]
            ]);
}

function initState_decode(decoder_htmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var links = Decco.arrayFromJson((function (param) {
          return link_decode(decoder_htmlElement, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "links"), null));
  if (links.TAG === /* Ok */0) {
    var v$1 = Belt_Option.getWithDefault(Js_dict.get(dict$1, "linkGroups"), null);
    var linkGroups = CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_decode, v$1);
    if (linkGroups.TAG === /* Ok */0) {
      var step = t_decode$4(Belt_Option.getWithDefault(Js_dict.get(dict$1, "step"), null));
      if (step.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  links: links._0,
                  linkGroups: linkGroups._0,
                  step: step._0
                }
              };
      }
      var e = step._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".step" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = linkGroups._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".linkGroups" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = links._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".links" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function matchingDomAnchorElements(urlPatterns, links) {
  return ArrayUtils$SmartcutsMacros.filterMap((function (link) {
                var arg = Webapi__Dom__Element.ofNode(link);
                var element = (function (param) {
                      return OptionUtils$SmartcutsMacros.getExn(param, arg);
                    })("Expect a[href] as element");
                var arg$1 = DOM$SmartcutsMacros.HtmlAnchorElement.ofElement(element);
                var href = (function (param) {
                      return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                    })("Expect a[href] as html anchor element").href;
                var url = URLUtils$SmartcutsMacros.$$URL.fromString(href);
                if (url !== undefined) {
                  if (Belt_Array.some(urlPatterns, (function (param) {
                            return UrlConstraint$SmartcutsMacros.UrlPattern.doesMatchUrl(url, param);
                          })) && DOM__Element$SmartcutsMacros.isVisibleOnPage(element)) {
                    return Caml_option.some(element);
                  } else {
                    return ;
                  }
                } else {
                  if (href !== "") {
                    console.warn("Invalid url. Ignoring.", href);
                  }
                  return ;
                }
              }), links);
}

var LinkGroup;

exports.Constants = Constants;
exports.ClickTarget = ClickTarget;
exports.PaginateFnWithPolymorphicClickTargetRepresentation = PaginateFnWithPolymorphicClickTargetRepresentation;
exports.LinkGroup = LinkGroup;
exports.LinkGroups = LinkGroups;
exports.Link = Link;
exports.link_encode = link_encode;
exports.link_decode = link_decode;
exports.Links = Links;
exports.remainingPages_encode = remainingPages_encode;
exports.remainingPages_decode = remainingPages_decode;
exports.remainingPagesFromPageUntil = remainingPagesFromPageUntil;
exports.stringifyRemainingPages = stringifyRemainingPages;
exports.pageAction_encode = pageAction_encode;
exports.pageAction_decode = pageAction_decode;
exports.Step = Step;
exports.initState_encode = initState_encode;
exports.initState_decode = initState_decode;
exports.matchingDomAnchorElements = matchingDomAnchorElements;
/* uuid Not a pure module */
